// extracted by mini-css-extract-plugin
export default {"container":"TermoServico_container__NzbYh","wrapper":"TermoServico_wrapper__4tWDt"};